// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1hGN7","modalForm":"UpgradeEpcsModal_modalForm__2985l","modalFooter":"UpgradeEpcsModal_modalFooter__3zIrK"};